import { create } from 'zustand';
import { getCompanyAddress, getCompanies, getCompanyById, addCompanyAddress, getCompanyAddressById, updateCompanyAddress, patchCompany, addCompany } from 'services';

// Компании аутстафф
export const useCompaniesStore = create((set) => ({
	companies: [],
	singleCompany: {},
	selectedCompany: null, // выбранная компания
	selectedExternalCompany: null, // выбранная компания оптовик
	loading: false,
	getCompanies: async (company_type) => {
		set({ loading: true });
		const companies = await getCompanies(company_type);
		set({ companies, loading: false });
	},
	getCompanyById: async (id) => {
		const singleCompany = await getCompanyById(id);
		set({ singleCompany });
	},
	addCompany: async (companyData) => {
		await addCompany(companyData);
	},
	patchCompany: async (companyData) => {
		await patchCompany(companyData);
	},
	setSelectedCompany: (company) => {
		set({ selectedCompany: company });
	},
	setSelectedExternalCompany: (company) => {
		set({ selectedExternalCompany: company });
	},
	clearSelectedExternalCompany: () => {
		set({ selectedExternalCompany: null });
	}
}))

// Адреса компаний
export const useCompanyAddress = create((set) => ({
	companyAddress: [],
	singleCompanyAddress: {},
	loading: false,
	getCompanyAddress: async () => {
		set({ loading: true });
		const companyAddress = await getCompanyAddress();
		set({ companyAddress, loading: false });
	},
	addCompanyAddress: async (addressData) => {
		set({ loading: true });
		const companyAddress = await addCompanyAddress(addressData);
		set({ companyAddress, loading: false });
	},
	getCompanyAddressById: async (id) => {
		const singleCompanyAddress = await getCompanyAddressById(id);
		set({ singleCompanyAddress });
	},
	updateCompanyAddress: async (addressData) => {
		set({ loading: true });
		await updateCompanyAddress(addressData);
		set({ loading: false });
	},
}))

